import * as React from 'react'
import Expander_helper from './Expander_helper'
import $ from 'jquery'

import GridHeader from './GridHeaderHelper'

interface MyProps {
    on_reset: () => void
}
type MyState = {}

class ListgridButtons extends React.PureComponent<MyProps,MyState> {
    constructor(props: MyProps) {
        super(props)

	this.reset_filters = this.reset_filters.bind(this)
    }

    componentDidMount(){
	window.addEventListener("afterprint", this.after_print)
    }

    after_print(){
	$('.listgrid .buttons-row').show()
	$('#page header').show()
	$('#page #item-header').show()
	$('#page .bp-wrap > #object-nav').show()
    }
    print_grid(){
	$('.listgrid .buttons-row').hide()
	$('#page header').hide()
	$('#page #item-header').hide()
	$('#page .bp-wrap > #object-nav').hide()
	setTimeout(()=>{
	    window.print()
	},400)
    }
    reset_filters(){
	this.props.on_reset()
    }

    render(){
	let exp = new Expander_helper()
	return (
    		<div className="buttons-row">
    		    <span className="cf-button reset-filters" onClick={this.reset_filters}>Filters terugzetten</span>
    		    <span className="cf-button expand-all" onClick={()=>exp.expand_all()}>Alles openklappen</span>
    		    <span className="cf-button collapse-all" onClick={()=>exp.collapse_all()}>Alles dichtklappen</span>
    		    <span className="cf-button print" onClick={this.print_grid}>Print</span>
		</div>
	)
    }

}
export default ListgridButtons

